// Generated by purs version 0.13.8
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Describable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Describable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Runnable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Runnable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Typeable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Typeable/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var trimString = {
    name: "trim",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableString)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableString))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString)))(Data_String_Common.trim),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "string",
        description: "Any string"
    } ])({
        name: "trimmed string",
        description: "The given string but without spaces at the end and at the start"
    })
};
var stringLength = {
    name: "length",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableString)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableInt))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableInt)))(Data_String_CodePoints.length),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "string",
        description: "Any string"
    } ])({
        name: "length",
        description: "The number of characters in the given string"
    })
};
var reverseString = {
    name: "reverse",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableString)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableString))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString)))(function ($0) {
        return Data_String_CodePoints.fromCodePointArray(Data_Array.reverse(Data_String_CodePoints.toCodePointArray($0)));
    }),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "string",
        description: "Any string"
    } ])({
        name: "reversed string",
        description: "The given string in reverse"
    })
};
var concatStrings = {
    name: "concat strings",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableString)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableString)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableString)))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString))))(Data_Semigroup.append(Data_Semigroup.semigroupString)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "first string",
        description: "Any string"
    }, {
        name: "second strings",
        description: "Any string"
    } ])({
        name: "a ++ b",
        description: "The result of 'glueing' the strings together"
    })
};
var stringNodes = [ stringLength, concatStrings, reverseString, trimString ];
module.exports = {
    stringNodes: stringNodes
};
